import React from 'react';
import { Skeleton } from '@mui/material';

const FilterDisclaimerLoading = () => {
  return (
    <>
      <Skeleton
        height="23px"
        width="89%"
        sx={{
          margin: '6px 0px'
        }}
      />
      <Skeleton
        height="23px"
        width="100%"
        sx={{
          margin: '6px 0px'
        }}
      />
      <Skeleton
        height="23px"
        width="78%"
        sx={{
          margin: '6px 0px'
        }}
      />
    </>
  );
};

export default FilterDisclaimerLoading;
